import SourcesManageDataForm from './SourcesManageDataForm';

export default SourcesManageDataForm;
